import {
    Button, Card, CircularProgress, Dialog, DialogContent,
    DialogTitle, Divider, Grid, IconButton, TextField
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import React, { useEffect, useState, } from "react";
import { connect } from "react-redux";
import { getRegionOption } from "store/app/farm-management/farm-records/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { Required } from "ui-component/custom-components/mandatory";
import { stateCreate, stateCreateErrorClear } from "store/app/form-management/state-configuration/actions";
import { AllowedSpecialCharacters, AllowedSpecialCharactersPaste } from "helper/regex";
import VWDropdown from "components/dropdown";
import { unionBy } from 'lodash';

const CreateState = (props) => {

    const { open, filter, paginationData, errorMessage, onClose, isPending } = props;

    const [stateData, setStateData] = useState();
    const [errors, setErrors] = useState({});

    //--------------------Region---------------------------
    const [regionOptions, setRegionOptions] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState();
    console.log("selectedRegion: ", selectedRegion);
    const loadRegionOption = (filter, page, pageSize) => {
        return props.getRegionOption(filter, "create", page, pageSize)
    }

    const handleRegionSelect = (option) => {
        const { label, value } = option || {};
        setSelectedRegion(option);
        setStateData({
            ...stateData,
            regionName: label,
            regionId: value
        })
        setErrors({
            ...errors,
            regionName: null,
        })
    }

    useEffect(() => {
        props.stateCreateErrorClear();
        setStateData();
        setSelectedRegion();
        setErrors({});
    }, [open])

    const validateOnchange = (e) => {
        const { name, value } = e.target;

        setStateData({
            ...stateData,
            [name]: value
        })
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const handleStateCreate = (e) => {
        e.preventDefault();

        const { regionName, stateName } = stateData || {};
        const currentErrors = {};

        if (!stateName && !stateName?.trim()) {
            currentErrors.stateName = 'State/Export name is required';
        }
        if (!regionName && !regionName?.trim()) {
            currentErrors.regionName = 'Region name is required';
        }
        setErrors(currentErrors);

        if (Object.keys(currentErrors).length === 0) {
            props.stateCreate(stateData, filter, paginationData);
        }
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog open={open} maxWidth={'xs'} fullWidth onClose={validateClose}>
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Create State/Export
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                {errorMessage && <ErrorAlert content={errorMessage} />}
                                <form>
                                    <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                        <Grid item >
                                            <TextField
                                                label={<div >State/Export Name <Required /></div>}
                                                sx={{ mt: 1 }}
                                                fullWidth
                                                autoFocus
                                                autoComplete="off"
                                                size="small"
                                                name='stateName'
                                                type='text'
                                                onChange={validateOnchange}
                                                onKeyDown={AllowedSpecialCharacters}
                                                onPaste={AllowedSpecialCharactersPaste}
                                                error={errors?.stateName}
                                                helperText={errors?.stateName}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <VWDropdown
                                                label="Region Name"
                                                name="regionName"
                                                multiple={false}
                                                // disablePortal={true}
                                                getOptions={loadRegionOption}
                                                onSelect={handleRegionSelect}
                                                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                                selectedOption={selectedRegion || null}
                                                options={regionOptions}
                                                setOptions={(options) => {
                                                    setRegionOptions((prev) => unionBy(prev, options, "value"));
                                                }}
                                                isRequired={true}
                                                error={errors?.regionName}
                                            />
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleStateCreate}
                                                size="small"
                                                color="primary"
                                                disabled={isPending || Object.keys(removeEmptyKeys(errors))?.length > 0}
                                            >
                                                {isPending ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <CircularProgress size={'20px'} color='inherit' />
                                                    Loading...
                                                </div>
                                                    : 'Submit'
                                                }
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={onClose}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                            >
                                                Close
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    isPending: state.states.isStateCreatePending,
    errorMessage: state.states.stateCreateErrorMessage,
})
const mapDispatchToProps = (dispatch) => ({
    stateCreate: (formData, filter, paginationData) => dispatch(stateCreate(formData, filter, paginationData)),
    stateCreateErrorClear: () => dispatch(stateCreateErrorClear()),
    getRegionOption: (filter, type, page, pageSize) => dispatch(getRegionOption(filter, type, page, pageSize)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateState);